export interface IAppointmentSlot {
  start: Date;
  end: Date;
}

export interface IProviderCalendarApiResponse {
  slots: IAppointmentSlotApiResponse[];
}

export interface IAppointmentSlotApiResponse {
  start: string;
  end: string;
}

export function convertApiResponse(response: IAppointmentSlotApiResponse): IAppointmentSlot {
  return {
    start: new Date(response.start),
    end: new Date(response.end)
  };
}
